import type * as React from 'react';

import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col, Container, type CuiTheme, Row } from '@crehana/ui';
import { useMe } from '@crehana/web/ReactContexts/AuthContext';

import type { PreCampaignProps } from '@/views/Campaign/types';

import SignupForm from './components/SignupForm';
import { LeftContainer, Wrapper } from './Hero.styles';

const Hero: React.FC<
  React.PropsWithChildren<PreCampaignProps['preHero'] & { h1?: string }>
> = ({
  backgroundDesktop,
  backgroundMobile,
  h1,
  dateDescription,
  description,
  logoMobile,
  logoDesktop,
}) => {
  const { me, loading } = useMe();

  return (
    <Wrapper className="relative overflow-hidden">
      <div className="hidden lg:block absolute inset-0">
        {backgroundDesktop && (
          <Image
            objectFit="cover"
            objectPosition="bottom"
            alt="Background desktop"
            layout="fill"
            src={backgroundDesktop}
          />
        )}
      </div>

      <div className="lg:hidden absolute inset-0">
        {backgroundMobile && (
          <Image
            objectFit="cover"
            objectPosition="bottom"
            alt="Background mobile"
            layout="fill"
            src={backgroundMobile}
          />
        )}
      </div>
      <Container className="sm:py-64 md:pt-96 lg:relative">
        <Row className="relative">
          <Col xs={12} md={6}>
            <LeftContainer className="text-center md:text-left mt-16 relative z-2 mr-auto ml-auto mb-52 md:m-0">
              {logoMobile && (
                <div
                  className="md:hidden mb-40 mt-96 md:mt-56 relative m-auto"
                  css={`
                    width: 250px;
                    height: 70px;
                    ${({ theme }: { theme: CuiTheme }) =>
                      theme.breakpoints.up('sm')} {
                      width: 360px;
                      height: 100px;
                    }
                  `}
                >
                  <Image
                    objectFit="contain"
                    objectPosition="center"
                    alt="Campaign logo"
                    layout="fill"
                    src={logoMobile}
                  />
                </div>
              )}
              {logoDesktop && (
                <div
                  className="hidden md:block mb-40 mt-96 md:mt-56 relative m-auto"
                  css={`
                    width: 420px;
                    height: 120px;
                  `}
                >
                  <Image
                    alt="Campaign logo"
                    layout="fill"
                    objectFit="contain"
                    objectPosition="center"
                    src={logoDesktop}
                  />
                </div>
              )}
              <p className="font-body1 mb-16 sm:mb-24 md:mb-40 text-white text-center">
                {description}
              </p>{' '}
              <h3 className="font-h3 text-white text-center">
                {dateDescription}
              </h3>
            </LeftContainer>
          </Col>
          <Col
            xs={12}
            sm={8}
            md={6}
            offset={{ sm: 2, md: 0 }}
            className="z-2 hidden sm:block md:mt-48"
          >
            {!loading && !me && (
              <SignupForm title={h1} wrapperClassName="ml-auto lg:m-auto " />
            )}
          </Col>
        </Row>
      </Container>
      <div className="sm:hidden">
        <SignupForm title={h1} wrapperClassName="ml-auto lg:m-auto " />
      </div>
    </Wrapper>
  );
};

export default Hero;
